import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.query.rolle-mitteilung-optionen';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationRolleMitteilungOptionenEffects {

    RolleMitteilungOptionen$ = createEffect(() => this.actions$.pipe(
        ofType(ac.GET_ROLLE_MITTEILUNG_OPTIONEN),
        mergeMap((x: ac.GetRolleMitteilungOptionenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().getRolleMitteilungOptionen(x.rolle_id).pipe(
                map((result: any) => {
                    return new ac.GetRolleMitteilungOptionenErfolgreichAction(result, x.rolle_id, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.GetRolleMitteilungOptionenFehlerAction(error, x.rolle_id, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.KommunikationQueryService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.KommunikationQueryService {
        if (this.service === null) {
            this.service = this.injector.get(api.KommunikationQueryService);
        }
        return this.service;
    }
}
